import loadTeasers from "./loadTeasers";
import iframeHeightSetter from "./iframeHeightSetter";

document.addEventListener('DOMContentLoaded', async () => {
    if (document.querySelector('.article')) {
        const teaserElement = document.querySelector('.relevant');

        let currentUrl = window.location.href;
        const previewMatch = currentUrl.match(/\/bl\/preview\/(\d+)/);
        const options = {};
        if (previewMatch) {
            options.id = previewMatch[1];
            currentUrl = '/bl/preview'
        }

        if (!await loadTeasers(currentUrl, teaserElement, options)) {
            return;
        }
        document.querySelector('h2.d-none').classList.remove('d-none');
        teaserElement.classList.remove('d-none');
        setTimeout(
            () => teaserElement.querySelectorAll('.invisible')
                .forEach(teaser => teaser.classList.remove('invisible'))
            , 100
        );

        iframeHeightSetter('.blog-embed iframe.embed-video-auto-height');
    }
})